<div [formGroup] = 'formData'>
    <input (change)="mudarValor()" formControlName="data" type="date" value="10/10/2022" class="form-control" id="{{ID}}" style="padding-right: 0 ;">
</div>

